import { Injectable } from '@angular/core';
import { ThemeConfig } from '../../../assets/data/enum/themeConfig';

@Injectable({ providedIn: 'root' })
export class TakeLanguageOfBrowserService {
  private readonly DEFAULT_LANG = 'en';

  private readonly languageMap: Record<string, string> = {
    it: 'it',
    de: 'de',
    es: 'es',
    en: 'en',
    fr: 'fr',
    pt: 'pt',
    'pt-BR': 'pt_BR',
    br: 'pt_BR',
    el: 'el',
    ru: 'ru',
    pl: 'pl',
    hu: 'hu',
    sl: 'sl',
    ro: 'ro',
    uk: 'uk',
    tr: 'tr',
    nl: 'nl',
    da: 'da',
    bg: 'bg',
    hi: 'hi',
  };

  getLanguage(): string {
    const rawLang = navigator.language || (navigator as any).userLanguage || this.DEFAULT_LANG;

    // Normalize to lowercase and replace underscore with hyphen
    const normalizedLang = rawLang.toLowerCase().replace('_', '-');

    // Try to see if the full language code is mapped (e.g., pt-BR)
    let resolvedLang = this.languageMap[normalizedLang];

    // Otherwise, try just the base part (e.g., pt)
    if (!resolvedLang) {
      const baseLang = normalizedLang.substring(0, 2);
      resolvedLang = this.languageMap[baseLang] || this.DEFAULT_LANG;
    }

    // If ThemeConfig forces a default language, apply it only if not already saved
    const savedLang = localStorage.getItem('crntLng');
    if (!savedLang) {
      const langToSave = ThemeConfig.forcedDefaultLang || resolvedLang;
      localStorage.setItem('crntLng', langToSave);
    }

    return resolvedLang;
  }
}
